import { categoryItems } from "../../../data/categories"

export default function CategoriesHeader() {
  return (
    <div className="lg:absolute left-0 top-full pt-8 w-[230px]
      bg-[var(--primary-dark)] lg:opacity-0 invisible
      group-hover:opacity-100 group-hover:visible
      transition-all duration-300 shadow-md z-50">
      <ul className="py-4 px-6 space-y-4">
        {categoryItems.map((item) => (
          <li key={item}>
            <a href="#"
              className="block text-[15px] font-medium text-[var(--text-light)] hover:opacity-80 transition"
              style={{ fontFamily: "Poppins, sans-serif" }}>
              {item}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}